<script setup lang="ts">
import { ref } from "vue";
import { useTranslation } from "i18next-vue";
import DRDropdownItem from "@/components/UI/DRDropdownItem.vue";
import LinkDiagnosticDialog from "./LinkDiagnosticDialog.vue";
import { useDeviceState } from "@/stores/DeviceState";

defineProps<{
  drawingId: number;
  projectId: number;
  /** Nom du plan — proposé comme nom d'ouvrage à la création. */
  drawingName?: string;
  diagnostic?: { id: number; name: string | null } | null;
}>();

const { t } = useTranslation();
const deviceState = useDeviceState();

const show = ref(false);
</script>

<template>
  <DRDropdownItem
    :disabled="!drawingId || !deviceState.isOnline"
    icon="bi-link-45deg"
    :label="t('dashboard:drawings.linkDiagnostic.label')"
    @select="show = true"
  />
  <LinkDiagnosticDialog
    v-model="show"
    :drawing-id="drawingId"
    :project-id="projectId"
    :drawing-name="drawingName"
    :diagnostic="diagnostic"
  />
</template>

<style lang="scss" scoped></style>
